var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2537_4849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6245 7.22356C10.7485 7.22356 9.39255 6.22756 7.96455 6.26356C6.08055 6.28756 4.35255 7.35556 3.38055 9.04756C1.42455 12.4436 2.87655 17.4596 4.78455 20.2196C5.72055 21.5636 6.82455 23.0756 8.28855 23.0276C9.69255 22.9676 10.2205 22.1156 11.9245 22.1156C13.6165 22.1156 14.0965 23.0276 15.5845 22.9916C17.0965 22.9676 18.0565 21.6236 18.9805 20.2676C20.0485 18.7076 20.4926 17.1956 20.5166 17.1116C20.4806 17.0996 17.5766 15.9836 17.5406 12.6236C17.5166 9.81556 19.8325 8.47156 19.9405 8.41156C18.6205 6.47956 16.5925 6.26356 15.8845 6.21556C14.0365 6.07156 12.4885 7.22356 11.6245 7.22356V7.22356ZM14.7445 4.39156C15.5245 3.45556 16.0405 2.14756 15.8965 0.851562C14.7805 0.899563 13.4365 1.59556 12.6325 2.53156C11.9125 3.35956 11.2885 4.69156 11.4565 5.96356C12.6925 6.05956 13.9645 5.32756 14.7445 4.39156V4.39156Z",
    fill: "#1A7DC7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2537_4849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple_logo.46ab5f0b60aced53022c604ce5393b1a.svg";
export { ForwardRef as ReactComponent };